<template>
    <v-navigation-drawer v-model="drawer" :rail="false" :permanent="mdAndUp" :temporary="!mdAndUp"
        v-if="menu && menu.length > 0">
        <v-list density="compact" nav class="mt-1 ml-0 pl-0 mr-0 pr-0" v-model:opened="opened">
            <v-list-item v-for="(item, index) in vociSingole" :key="'s-' + index" :title="item.text"
                :active="isActive(item.link)" color="primary" rounded="lg" @click="naviga(item)">
                <template #prepend>
                    <v-icon :color="item.colore">{{ item.img }}</v-icon>
                </template>
            </v-list-item>

            <v-list-group v-for="gruppo in gruppi" :key="gruppo.nome" :value="gruppo.nome">
                <template #activator="{ props }">
                    <v-list-item v-bind="props" :title="gruppo.nome" rounded="lg">
                        <template #prepend>
                            <v-icon :color="gruppo.colore">{{ gruppo.icona }}</v-icon>
                        </template>
                    </v-list-item>
                </template>
                <v-list-item v-for="(item, index) in gruppo.voci" :key="index" :prepend-icon="item.img"
                    :title="item.text" :active="isActive(item.link)" color="primary" rounded="lg" @click="naviga(item)"
                    style="padding-left: 20px!important" />
            </v-list-group>
        </v-list>

        <!-- Logo aziendale in fondo alla sidebar, personalizzato per tenant e
             visibile a tutti i suoi utenti (caricato da un Admin in /mia-azienda). -->
        <template v-if="logoUrl" #append>
            <div class="d-flex justify-center pa-3">
                <v-img :src="logoUrl" max-height="48" max-width="140" contain />
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: "LeftBarComponent",
    props: {
        menu: { type: Array, default: () => [] },
        modelValue: { type: Boolean, default: true },
        logoUrl: { type: String, default: null },
    },
    emits: ["esci", "update:modelValue"],

    data() {
        return {
            drawer: this.modelValue,
            // Gruppi attualmente espansi (v-model:opened della v-list): il gruppo
            // contenente la pagina attiva viene aggiunto automaticamente (vedi watch
            // su $route.path), il resto è a discrezione dell'utente per la sessione.
            opened: [],
        };
    },

    computed: {
        // Vuetify 3 espone useDisplay() come composable puro: in Options API
        // replichiamo lo stesso comportamento leggendo direttamente $vuetify.display,
        // reso disponibile globalmente dal plugin Vuetify.
        mdAndUp() {
            return this.$vuetify.display.mdAndUp;
        },

        // Voci singole in cima, fuori da qualunque gruppo (Home/Calendario/Mezzi):
        // l'ordine arriva già corretto dal backend (ORDER BY ProgOrder), filter lo preserva.
        // Tra queste, solo "Mezzi" rappresenta un ambito a sé (Home/Calendario sono
        // trasversali): riceve il colore del suo ambito, le altre nessun colore.
        vociSingole() {
            return this.menu
                .filter((m) => !m.gruppo)
                .map((m) => ({ ...m, colore: m.link === "/mezzi" ? "mezzi" : undefined }));
        },

        // Gruppi tematici comprimibili: ordine, icone e colore d'ambito fissi lato
        // frontend (solo 3 gruppi voluti, non serve un campo DB dedicato). Un gruppo
        // senza voci per il ruolo corrente (filtro già applicato lato backend) non
        // viene mostrato.
        gruppi() {
            const DEFINIZIONE = [
                { nome: "Manutenzioni", icona: "mdi-wrench", colore: "manutenzioni" },
                { nome: "Amministrazione", icona: "mdi-cash-multiple", colore: "amministrazione" },
                { nome: "Gestione", icona: "mdi-account-cog", colore: "gestione" },
            ];
            return DEFINIZIONE
                .map((g) => ({ ...g, voci: this.menu.filter((m) => m.gruppo === g.nome) }))
                .filter((g) => g.voci.length > 0);
        },
    },

    watch: {
        modelValue(val) {
            this.drawer = val;
        },
        drawer(val) {
            this.$emit("update:modelValue", val);
        },

        // Apre automaticamente il gruppo che contiene la pagina corrente, così una
        // voce attiva non resta mai nascosta dentro un gruppo chiuso. Osservato sia sul
        // cambio pagina sia sull'arrivo (asincrono) del menu da Main.vue, altrimenti al
        // primo caricamento "gruppi" sarebbe ancora vuoto quando questo watch scatta.
        "$route.path": {
            immediate: true,
            handler() {
                this.apriGruppoAttivo();
            },
        },
        menu: {
            immediate: true,
            handler() {
                this.apriGruppoAttivo();
            },
        },
    },

    methods: {
        apriGruppoAttivo() {
            const gruppoAttivo = this.gruppi.find((g) => g.voci.some((item) => this.isActive(item.link)));
            if (gruppoAttivo && !this.opened.includes(gruppoAttivo.nome)) {
                this.opened.push(gruppoAttivo.nome);
            }
        },

        isActive(link) {
            if (!link || !link.startsWith("/")) return false;
            return this.$route.path === link || this.$route.path.startsWith(link + "/");
        },

        naviga(item) {
            if (item.link && item.link.startsWith("/")) {
                const { fullPath } = this.$router.resolve(item.link);
                this.$router.push(fullPath);
            } else if (item.link && item.link.startsWith("@")) {
                if (item.link == "@esci") this.$emit("esci");
            }
        },
    },
};
</script>